import { render, staticRenderFns } from "./SelectPlan.container.vue?vue&type=template&id=f72c34d2&scoped=true&"
import script from "./SelectPlan.container.vue?vue&type=script&lang=ts&"
export * from "./SelectPlan.container.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPlan.container.vue?vue&type=style&index=0&id=f72c34d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72c34d2",
  null
  
)

export default component.exports